export default __webpack_public_path__ + "static/media/backbtn.5b6e2f65.svg";